import { useRouter } from '@uirouter/react';
import { useImmerAtom, useSetImmerAtom } from 'jotai-immer';
import { ROUTE_CREATE, ROUTE_UPDATE } from '../../vendor_const';
import { pageStateAtom } from '../vendor_list_atoms';
import { PageStoreHook, VendorDataItem } from '../vendor_list_types';
import { useCallback } from 'react';
import { editPageStateAtom } from '../../edit/vendor_edit_atoms';

export const useVendorListStore = (): PageStoreHook => {
    const router = useRouter();
    const [state] = useImmerAtom(pageStateAtom);
    const setEditState = useSetImmerAtom(editPageStateAtom);

    const routeToCreate = useCallback(() => {
        router.stateService.go(ROUTE_CREATE);
        setEditState(draft => {
            draft.mode = 'CREATE';
            draft.id = '';
            draft.title = 'Create Vendor';
        });
    }, [setEditState, router.stateService]);

    const routeToEdit = useCallback(
        (rowItem: VendorDataItem) => {
            router.stateService.go(ROUTE_UPDATE, { Id: rowItem.Id });
            setEditState(draft => {
                draft.mode = 'UPDATE';
                draft.id = rowItem.Id;
                draft.title = 'Edit Vendor';
                draft.isTPA = rowItem.Type === 'TPA';
            });
        },
        [setEditState, router.stateService],
    );

    return {
        canEdit: state.canEdit,
        routeToCreate,
        routeToEdit,
    };
};
